module.exports = __webpack_public_path__ + "img/nav_btn_menu_s.e1cb0984.png";